<template>
  <div class="custom-order">
    <Breadcrumb></Breadcrumb>

    <!-- 过滤条件 -->
    <div class="form-body">
      <el-form :model="form" ref="form" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="平台产品SKU：" class="item">
                <el-input
                  v-model="form.amazonSku"
                  class="input"
                  size="small"
                  clearable
                />
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="设计编号：" class="item">
                <el-input
                  v-model="form.designId"
                  class="input"
                  size="small"
                  clearable
                />
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="item right">
              <el-button type="primary" size="small" @click="getData(1)"
                >搜索</el-button
              >
              <el-button type="default" size="small" @click="reset"
                >重置</el-button
              >
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 表格 -->
    <div class="table-body">
      <div class="top">
        <div class="left"></div>
        <div class="right">
          <pagination
            :total="total"
            :page.sync="form.pageNum"
            :limit.sync="form.pageSize"
            @pagination="getData"
          />
        </div>
      </div>
      <el-table id="myOrder" ref="table" :data="tableData" class="table">
        <el-table-column width="420px" align="center" label="平台产品">
          <template slot-scope="scope">
            <div class="table-info-wrap">
              <div class="table-info">
                <div class="left">
                  <img
                    class="mini-img"
                    :src="
                      scope.row.amazonPicUrl ? scope.row.amazonPicUrl : noImage
                    "
                    slot="reference"
                  />
                </div>
                <div class="right" style="width:290px;">
                  <div
                    :title="scope.row.amazonProductName"
                    class="text-ellipsis"
                  >
                    {{ scope.row.amazonProductName }}
                  </div>
                  <div>{{ scope.row.amazonSku }}</div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="420px" align="center" label="定制产品">
          <template slot-scope="scope">
            <div class="table-info-wrap">
              <div class="table-info">
                <div class="left">
                  <img
                    class="mini-img"
                    :src="scope.row.picUrl"
                    slot="reference"
                  />
                </div>
                <div style="width:290px;" class="right">
                  <div
                    style="width:290px;"
                    :title="scope.row.designProName"
                    class="text-ellipsis"
                  >
                    <a
                      @click="handleJumpDetail(scope.row.designId)"
                      href="javascript:void(0)"
                      >{{ scope.row.designProName }}</a
                    >
                  </div>
                  <div>成品编号：{{ scope.row.designId }}</div>
                  <div>
                    颜色：{{
                      scope.row.properVal
                        ? scope.row.properVal.split(":")[0]
                        : ""
                    }}
                    尺码：{{
                      scope.row.properVal
                        ? scope.row.properVal.split(":")[1]
                        : ""
                    }}
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作人"
          align="center"
          prop="nickName"
          width="120"
        >
         <template slot-scope="scope">
            {{ scope.row.nickName ?  scope.row.nickName : scope.row.operNo}}
          </template>
        </el-table-column>
        <el-table-column align="center" label="关联时间">
          <template slot-scope="scope">
            <div class="loan-wrap">
              <div>
                {{ scope.row.createTime }}
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作" width="120">
          <template slot-scope="scope">
              <div class="operate" @click="relate(scope.row)">
              修改
            </div>
            <div class="operate" @click="deleteFn(scope.row)">
              删除
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :total="total"
        :page.sync="form.pageNum"
        :limit.sync="form.pageSize"
        @pagination="getData"
      />
    </div>
      <RelateOrder
      :visible="showEdit"
      :order="currentOrder"
      @onClose="hideEdit"
      @update="handleUpdate"
    />
  </div>
</template>

<script>
import Breadcrumb from "@/components/common/Breadcrumb"
import { mapGetters } from "vuex"
import { listLink, deleteLink } from "@/api/order/all"
import noImage from "@/assets/images/no_image.png"
import RelateOrder from "./components/RelateOrder"

export default {
  name: "relatedOrder",
  components: {
    Breadcrumb,
    RelateOrder
  },
  data() {
    return {
      form: {
        amazonSku: "",
        designId: "",
        pageNum: 1,
        pageSize: 10,
      },
      modalTitle: "",
      modalText: "",
      statusText: "", 
      statusMap: null,
      total: 0,
      tableData: [], // 表格数据
      currentOrder: {},
      currentAppId: "",
      noImage: noImage,
      showEdit: false
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  mounted() {
    this.getData()
  },
  methods: {
    // 搜索
    getData() {
      let params = Object.assign({}, this.form)

      listLink(params).then((res) => {
        if (res.code !== 200) {
          this.$message.error("获取订单列表失败")
        } else {
          this.total = res.total
          this.tableData = res.rows
        }
      })
    },
    handleJumpDetail(designId) {
      this.$router.push({
        path: "/select/custom/product",
        query: {
          designId: designId,
        },
      })
    },
    // 重置
    reset() {
      this.form = {
        amazonSku: "",
        designId: "",
      }
    },
    deleteFn(data) {
      this.$confirm(
        "是否确认删除产品关联，删除后，再次导入产品需要重新关联？",
        "删除确认",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        deleteLink(data.id).then((res) => {
          if (res.code !== 200) {
            this.$message.error("删除失败")
          } else {
            this.getData()
            this.$message({
              type: "success",
              message: "删除成功!",
            })
          }
        })
      })
    },
    hideEdit() {
      this.showEdit = false
      this.getData()
    },
    handleUpdate() {
      this.showEdit = false
      let appNo = this.$route.query.appNo
      if (appNo) {
        this.$router.push({
          path: "/order/order_aid/relatedOrder",
          query: {
            appNo: appNo,
          },
        })
      } else {
        this.getData()
      }
    },
    
    relate(data) {
      
      // if(data.properVal){
      //   data.color = data.properVal.split(':')[0]
      //   data.size = data.properVal.split(':')[1]
      // }
      this.currentOrder = data
      this.showEdit = true
    },
  },
}
</script>

<style scoped>
.form-body {
  padding: 10px 20px;
}

.form-body .item {

}
.form-body .item.right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.table-body {
  margin-top: 10px;
  border: 1px solid #ebeef5;
  background: #fff;
  font-size: 12px;
  overflow: hidden;
}

.table-body /deep/.el-table .cell {
  padding: 0;
}

.table-body .top {
  padding: 0 0 8px 0;
  background: #fff;
  display: flex;
  justify-content: space-between;
  padding-right: 0;
}

.table-body > .table {
  margin-bottom: 10px;
}

.table-info-wrap {
  margin-bottom: -10px;
}

.table-info {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 10px;
  padding: 0 10px;
}

.table-info:last-child {
  margin-bottom: 0;
  border-bottom: 0;
}

.table-info .left {
  margin-right: 20px;
  width: 97px;
  height: 97px;
  border: 1px solid #ddd;
  margin-bottom: 10px;
}

.table-info .left .mini-img {
  width: 95px;
  height: 95px;
}

.table-info .right {
  font-size: 12px;
  margin: -12px 0 0 0;
}

.table-info .right div {
  text-align: left;
}

.loan-wrap {
  display: flex;
  flex-direction: column;
  display: flex;
  flex-direction: column;
  padding: 0 10px;
  font-size: 12px;
  text-align: center;
}

.loan-wrap .title.lw40 {
  width: 24px;
}

.loan-wrap .title {
  width: 48px;
  display: inline-block;
  text-align: justify;
  text-align-last: justify;
}

.operate {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 12px;
  color: #1e7ec8;
  cursor: pointer;
}
</style>
